define('app/../../components/loader',["knockout", "i18n"], function (ko, i18n) {
    var parseName = function (fullname) {
        var n = fullname.split('/');
        var directory = n[0];
        var filename = n.length > 1 ? n[1] : n[0];
        
        return {
            directory: directory,
            filename: filename
        };
    };
    
    return function (app) {
        var loader = {
            getConfig: function(name, callback) {
                var isInline = false;
                
                if(name.indexOf(":") == 0)
                {
                    name = name.substring(1);
                    isInline = true;
                }
                
                var viewModelConfig = name;
                var templateConfig = { element: name, isInline: isInline };
                
                callback({ viewModel: viewModelConfig, template: templateConfig });
            },
            loadTemplate: function(name, templateConfig, callback) {
                var tmpl = parseName(templateConfig.element);

                if(templateConfig.isInline) {
                    ko.components.defaultLoader.loadTemplate(name, '<!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->', callback);
                } else {
                    require(["text!../components/" + tmpl.directory + "/" + tmpl.filename + ".html"], function (componenthtml) {
                        ko.components.defaultLoader.loadTemplate(name, i18n.localizeTemplate(componenthtml), callback);
                    });
                }
            },
            loadViewModel: function(name, viewModelConfig, callback) {
                var tmpl = parseName(viewModelConfig);
                
                require(["../components/" + tmpl.directory + "/" + tmpl.filename],  function (component) {
                    var constructor = function(params)
                    {
                        return new component(params,  app);
                    };
                    
                    ko.components.defaultLoader.loadViewModel(name, constructor, callback);
                });
            }
        };

        ko.components.loaders.unshift(loader);
    };
});

